import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BackArrowIcon } from 'components/elements/Icons';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function DetailControls({ children, backButtonRoute }) {
  const { t } = useTranslation('labels');
  const classes = useStyles();

  return (
    <div className={classes.detailControls} data-testid="detail-controls">
      <Link to={backButtonRoute}>
        <button className={classes.backButton} type="button">
          <span className="sr-only">{t('back')}</span>
          <BackArrowIcon />
        </button>
      </Link>
      <div>{children}</div>
    </div>
  );
}

DetailControls.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  backButtonRoute: PropTypes.string.isRequired,
};

DetailControls.defaultProps = {
  children: null,
};

export default DetailControls;
